import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RivvyApiService } from '../../api/rivvy.service';

@Injectable({
  providedIn: 'root',
})
export class RivvyOutletService {
  private _hasBeenSummoned = new BehaviorSubject<boolean>(false);

  constructor(private rivvyApiService: RivvyApiService) {}

  get hasBeenSummoned$() {
    return this._hasBeenSummoned.asObservable();
  }

  isEnabled(accountId: number) {
    return this.rivvyApiService.isEnabled(accountId);
  }

  summon(): void {
    this._hasBeenSummoned.next(true);
  }

  dismiss(): void {
    this._hasBeenSummoned.next(false);
  }
}
